<template>
  <div>
    <RecipientMenu ref="recipientMenu" :position="menuPosition" :configuration="configuration" />
    <ReportsMenu ref="reportsMenu" :position="menuPosition" :configuration="configuration" />
    <ConfirmationMenu ref="confirmationMenu" :position="menuPosition" />

    <v-card-title class="headline pb-0">
      Recipients
      <span class="font-weight-light body-2">
        &nbsp;
        ⋅
        {{ configuration.recipients.length }}
        {{ pluralize('recipient', configuration.recipients.length)}}</span>
      <v-spacer />
      <v-text-field prepend-inner-icon="search" v-model="search" class="rounded font-weight-regular emphasize-clear" hide-details clearable @click:clear="search = ''" solo placeholder="Search recipients">
      </v-text-field>
    </v-card-title>
    <v-card-actions>
      <v-btn ref="addItem" @click="addItem()" outline small color="success">
        <v-icon>add</v-icon>
        <span class="text-">{{$t('Button.AddRecipient')}}</span>
      </v-btn>
    </v-card-actions>

    <v-divider />
    <v-data-table :pagination.sync="pagination" :headers="headers" :search="search" :items="items">
      <template v-slot:items="{ item, index }">
        <td class="text-xs-left break-all">{{ item.email }}</td>
        <td class="text-xs-left break-all">{{ item.name }}</td>
        <td class="text-xs-left break-all">
          <div v-if="item.reports.length == 0">
            All reports
          </div>
          <div v-else>
            <v-chip v-for="(report, reportIndex) in item.reports.slice(0, 10)" small :key="`report-${index}-${reportIndex}`">
              {{ report.name }}
            </v-chip>
            <v-chip small v-if="item.reports.length > 10">
              + {{ item.reports.length - 10 }} others
            </v-chip>
          </div>
        </td>
        <td class="text-xs-center">
          <v-btn class="mx-0" @click="editReports(item)" color="info" outline small>
            <span class="text-none">
              {{$t('Button.CustomizeReportsReceived')}}
            </span>
          </v-btn>
          <br />
          <v-btn class="ml-0" @click="editItem(item)" icon flat color="info" small>
            <v-icon>edit</v-icon>
          </v-btn>
          <v-btn class="mr-0" @click="removeItem(item)" icon flat color="error" small>
            <v-icon>clear</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import RecipientMenu from './RecipientMenu'
  import ReportsMenu from './ReportsMenu'
  import {
    reports,
  } from '@/helpers/discreteImportNotifications'

  import {
    pluralize,
  } from '@/helpers/strings'

  export default {
    components: {
      RecipientMenu,
      ReportsMenu,
    },
    props: {
      configuration: Object,
    },
    data: () => ({
      reports,
      search: null,
      headers: [{
        text: 'Email address',
        align: 'left',
        value: 'email',
      },
      {
        text: 'Recipient\'s Name',
        align: 'left',
        value: 'name',
      },
      {
        text: 'Reports',
        align: 'left',
        value: 'reports',
      },
      {
        text: 'Actions',
        align: 'center',
        value: 'actions',
      },
      ],
      pagination: {
        rowsPerPage: 10,
      },
      menuPosition: {
        x: null,
        y: null,
      },
    }),
    computed: {
      reportIndex() {
        let index = {}
        this.reports.forEach(report => index[report.id] = report)
        return index
      },
      items() {
        return this.configuration.recipients.map(recipient => ({
          ...recipient,
          reports: recipient.reportIds && recipient.reportIds.map(reportId => this.reportIndex[reportId]),
        }))
      },
    },
    methods: {
      pluralize,
      updateMenuPosition(event) {
        this.menuPosition = {
          x: event.x,
          y: event.y,
        }
      },
      addItem() {
        this.updateMenuPosition(event)
        this.$refs.recipientMenu.show()
      },
      editItem(item) {
        this.updateMenuPosition(event)
        this.$refs.recipientMenu.show(item)
      },
      editReports(item) {
        this.updateMenuPosition(event)
        this.$refs.reportsMenu.show(item)
      },
      async removeItem(item) {
        this.updateMenuPosition(event)
        let confirmationDetails = {
          title: 'Remove recipient',
          text: `Remove ${item.name || item.email} as a recipient?`,
          confirmText: 'Remove',
          cancelText: 'Cancel',
          color: 'error',
        }

        try {
          let hasConfirmed = await this.$refs.confirmationMenu.show(confirmationDetails)
          if (hasConfirmed) {
            let index = this.configuration.recipients.findIndex(r => r.email == item.email)
            this.configuration.recipients.splice(index, 1)
          }
        } catch (error) {
          // Cancelled promise
          console.warn(error)
        }
      },
    },
  }
</script>